import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_palm_pine: FaireCollectionEntity = {
  token: "col_palm-pine",
  type: "collection",
  name: "Palm & Pine",
  description: "Tropical meets traditional for a fresh holiday look.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1545048702-79362596cdc9?w=400&h=400&fit=crop",
  season: "winter",
  itemCount: 19,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
